// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-2b739d55]:root {
  --vl-theme-primary-color: #ffe615;
  --vl-theme-primary-color-60: rgb(100%, 94.1176470588%, 44.9411764706%);
  --vl-theme-primary-color-70: rgb(100%, 93.137254902%, 35.7647058824%);
  --vl-theme-primary-color-rgba-30: rgba(255, 230, 21, 0.3);
  --vl-theme-fg-color: #333332;
  --vl-theme-fg-color-60: rgb(52%, 52%, 51.7647058824%);
  --vl-theme-fg-color-70: rgb(44%, 44%, 43.7254901961%);
}
.vl-vi[data-v-2b739d55]::before, .vl-vi[data-v-2b739d55]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: inline-block;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-180deg[data-v-2b739d55]::before {
  display: inline-block;
  transform: rotate(180deg);
  vertical-align: middle;
}
.vl-vi-u-xs[data-v-2b739d55]::before {
  font-size: 0.8rem;
}
.vl-vi-u-s[data-v-2b739d55]::before {
  font-size: 1.3rem;
}
.vl-vi-u-m[data-v-2b739d55]::before {
  font-size: 1.7rem;
}
.vl-vi-u-l[data-v-2b739d55]::before {
  font-size: 2rem;
}
.vl-vi-u-xl[data-v-2b739d55]::before {
  font-size: 2.2rem;
}
.vl-vi-u-90deg[data-v-2b739d55]::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi-u-180deg[data-v-2b739d55]::before {
  display: inline-block;
  transform: rotate(180deg);
}
.vl-functional-header[data-v-2b739d55] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f9fc;
  padding: 0;
  margin: 0;
}
.vl-functional-header--has-actions[data-v-2b739d55]::before {
  height: 0px;
}
.vl-functional-header__profile[data-v-2b739d55] {
  display: flex;
  height: 45px;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
}
[data-v-2b739d55] .vl-functional-header__container {
  padding: 0 0 0 3rem;
  flex: 1;
  border-bottom: solid 1px #cbd2d9;
}
[data-v-2b739d55] .vl-functional-header__content {
  height: 45px;
}
[data-v-2b739d55] .vl-functional-header__actions {
  display: flex;
  align-items: center;
  height: 45px;
  padding: 0;
  min-width: 0;
  margin: 0;
}
[data-v-2b739d55] .vl-functional-header__actions ul,[data-v-2b739d55] .vl-functional-header__actions ul > div,[data-v-2b739d55] .vl-functional-header__actions li,[data-v-2b739d55] .vl-functional-header__actions .mo-accountpanel-dropdown,[data-v-2b739d55] .vl-functional-header__actions .mo-accountpanel-dropdown__toggle {
  height: 100%;
}
[data-v-2b739d55] .vl-functional-header__actions .mo-accountpanel-dropdown button:focus {
  outline: none !important;
}
[data-v-2b739d55] .vl-functional-header__actions li {
  padding: 0;
}
[data-v-2b739d55] .vl-functional-header__actions .mo-accountpanel-dropdown__toggle {
  padding: 0 3rem;
}
[data-v-2b739d55] .vl-functional-header__actions .mo-accountpanel-dropdown__toggle:hover {
  background-color: #cfd5dd;
}
@media screen and (max-width: 767px) {
[data-v-2b739d55] .vl-functional-header__container {
    padding: 0;
}
[data-v-2b739d55] .vl-functional-header__row {
    flex-wrap: wrap;
}
[data-v-2b739d55] .vl-functional-header__actions {
    flex: 0 0 100%;
    width: 100%;
    order: 1;
    padding: 0;
}
[data-v-2b739d55] .vl-functional-header__content {
    width: 100%;
    order: 2;
}
}
[data-v-2b739d55] .vl-functional-header__sub__action::before {
  display: none;
}
.vl-functional-header__sub__action[data-v-2b739d55] .vl-link__icon::before,
.vl-functional-header__sub__action .vl-link__icon[data-v-2b739d55]::after {
  font-size: 12px;
  padding: 0 0.6rem;
  color: #8695a8;
}
.vl-functional-header__sub__action[data-v-2b739d55] .vl-link {
  text-decoration: none;
  color: #333332;
}
.vl-functional-header__sub__action[data-v-2b739d55] .vl-link:hover {
  color: #05c;
}
.vl-functional-header__sub__action .vl-icon[data-v-2b739d55] {
  margin-left: 1rem;
  margin-right: 1rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
